import { API_BASE_URL, getRequest, postRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

export const fetchLearnerQuizCurrentApi = (moduleId, contentId) =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/quiz/current`,
        token: getToken(),
        uid: getUid(),
    });

export const startLearnerQuizApi = (moduleId, contentId) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/quiz/start`,
        data: {},
        token: getToken(),
        uid: getUid(),
    });

export const submitLearnerQuizApi = (moduleId, contentId, payload) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/quiz/submit`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const fetchLearnerQuizHistoryApi = (moduleId, contentId) =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/quiz/history`,
        token: getToken(),
        uid: getUid(),
    });

export const fetchLearnerQuizReviewApi = (moduleId, contentId, tentativeId) =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/quiz/review/${tentativeId}`,
        token: getToken(),
        uid: getUid(),
    });
